export function useMetaTitle() {
  const shopConfigStore = useShopConfigStore()
  const b2bConfigStore = useB2BConfigStore()
  const brandsStore = useBrandsStore()
  const userInfoStore = useUserInfoStore()
  const t = useTranslate()

  const currentBrand = brandsStore.selectedBrand

  const companyName = computed(() => {
    return currentBrand?.title ?? shopConfigStore.companyName
  })

  return {
    error(params: { statusCode: number | string }) {
      return t('meta.title.error', {
        statusCode: params.statusCode,
        company: companyName.value,
      })
    },
    login() {
      return t('meta.title.login', {
        company: companyName.value,
        selfServiceName: shopConfigStore.selfServiceName,
      })
    },
    landing() {
      const title = t('meta.title.landing', {
        company: companyName.value,
        userName: userInfoStore.firstNameInitial,
      })
      return title
    },
    shop() {
      return t('meta.title.shop', {
        company: companyName.value,
      })
    },
    shopSearch(params: { searchTerm: string }) {
      return t('meta.title.shopSearch', {
        searchTerm: params.searchTerm,
        company: companyName.value,
      })
    },
    productDetail(params: { productName: string }) {
      return t('meta.title.productDetail', {
        productName: params.productName,
        company: companyName.value,
      })
    },
    themeworlds() {
      return t('meta.title.themeworlds', {
        themeworldsMainTitle: b2bConfigStore.capsuleConfig.mainTitle,
        company: companyName.value,
      })
    },
    themeworldDetail(params: { themeworldName: string }) {
      return t('meta.title.themeworldDetail', {
        themeworldName: params.themeworldName,
        themeworldsMainTitle: b2bConfigStore.capsuleConfig.mainTitle,
        company: companyName.value,
      })
    },
    looks() {
      return t('meta.title.looks', {
        looksMainTitle: b2bConfigStore.lookConfig.mainTitle,
        company: companyName.value,
      })
    },
    lookDetail(params: { lookName: string }) {
      return t('meta.title.lookDetail', {
        lookName: params.lookName,
        looksMainTitle: b2bConfigStore.lookConfig.mainTitle,
        company: companyName.value,
      })
    },
    openOrders() {
      return t('meta.title.openOrders', {
        company: companyName.value,
      })
    },
    openOrderDetail(params: { wishlistId: number }) {
      return t('meta.title.openOrderDetail', {
        orderNumber: formatWishlistId(params.wishlistId),
        company: companyName.value,
      })
    },
    wishlistOverview() {
      return t('meta.title.wishlistOverview', {
        company: companyName.value,
      })
    },
    wishlistOverviewDetail(params: { wishlistId: number }) {
      return t('meta.title.wishlistOverviewDetail', {
        orderNumber: formatWishlistId(params.wishlistId),
        company: companyName.value,
      })
    },
    checkout(param?: { wishlistId?: number }) {
      return t('meta.title.checkout', {
        orderNumber: param?.wishlistId ? formatWishlistId(param.wishlistId) : '',
        company: companyName.value,
      })
    },
    checkoutThankYou(params?: { wishlistId?: number }) {
      return t('meta.title.checkoutThankYou', {
        orderNumber: params?.wishlistId ? formatWishlistId(params.wishlistId) : '',
        company: companyName.value,
      })
    },
    accountAddresses() {
      return t('meta.title.accountAddresses', {
        company: companyName.value,
      })
    },
    accountProfile() {
      return t('meta.title.accountProfile', {
        userName: userInfoStore.firstNameInitial,
        company: companyName.value,
      })
    },
    accountOpenOrders() {
      return t('meta.title.accountOpenOrders', {
        userName: userInfoStore.firstNameInitial,
        company: companyName.value,
      })
    },
    accountOrderHistory() {
      return t('meta.title.accountOrderHistory', {
        company: companyName.value,
      })
    },
    accountOrderHistoryDetail(params: { wishlistId: number }) {
      return t('meta.title.accountOrderHistoryDetail', {
        orderNumber: formatWishlistId(params.wishlistId),
        company: companyName.value,
      })
    },
    accountUsers() {
      return t('meta.title.accountUsers', {
        company: companyName.value,
      })
    },
    accountWishlists() {
      return t('meta.title.accountWishlists', {
        company: companyName.value,
      })
    },
    resources() {
      return t('meta.title.resources', {
        company: companyName.value,
      })
    },
    resourcesForm(params: { formName: string }) {
      return t('meta.title.resourcesForm', {
        formName: params.formName,
        company: companyName.value,
      })
    },
    blog() {
      return t('meta.title.blog', {
        company: companyName.value,
      })
    },
    blogDetail(params: { blogTitle: string }) {
      return t('meta.title.blogDetail', {
        blogTitle: params.blogTitle,
        company: companyName.value,
      })
    },
    team() {
      return t('meta.title.team', {
        company: companyName.value,
      })
    },
    cart() {
      return t('meta.title.cart', {
        company: companyName.value,
      })
    },
    mediaCenter() {
      return t('meta.title.mediaCenter', {
        company: companyName.value,
      })
    },
    legal() {
      return t('meta.title.legal', {
        company: companyName.value,
      })
    },
    legalDetail(params: { legalType: string }) {
      return t('meta.title.legalDetail', {
        legalType: params.legalType,
        company: companyName.value,
      })
    },
  }
}
